// Sectors and journeys in Martinique, to group the visits and estimate the
// road between them (the prototype's lib/geo.js).

export const CITY_COORDS = {
  'Fort-de-France': [14.6037, -61.0662],
  'Schœlcher': [14.6145, -61.0907],
  'Saint-Joseph': [14.6703, -61.0397],
  'Le Lamentin': [14.6133, -60.9997],
  Ducos: [14.5747, -60.9746],
  'Le Carbet': [14.7097, -61.1781],
  'Saint-Pierre': [14.7436, -61.1756],
  'Case-Pilote': [14.6403, -61.1356],
  Bellefontaine: [14.6681, -61.1606],
  'Le Robert': [14.6772, -60.9389],
  'La Trinité': [14.7386, -60.9636],
  'Sainte-Marie': [14.7833, -60.9908],
  'Le Gros-Morne': [14.7189, -61.0122],
  'Le François': [14.6153, -60.9031],
  'Le Vauclin': [14.545, -60.8386],
  'Les Trois-Îlets': [14.5394, -61.0367],
  'Le Diamant': [14.4766, -61.0222],
  'Sainte-Luce': [14.4686, -60.9244],
  'Sainte-Anne': [14.44, -60.8833],
  'Le Marin': [14.4686, -60.8697],
  'Rivière-Salée': [14.5276, -60.9696],
  'Rivière-Pilote': [14.4836, -60.9017],
  'Saint-Esprit': [14.5603, -60.9314],
  'Les Anses-d’Arlet': [14.4886, -61.0811],
};

const SECTORS = {
  'Fort-de-France': ['Fort-de-France', 'Schœlcher', 'Saint-Joseph'],
  'Le Lamentin': ['Le Lamentin', 'Ducos'],
  'Nord Caraïbe': ['Le Carbet', 'Saint-Pierre', 'Case-Pilote', 'Bellefontaine'],
  'Nord Atlantique': ['Le Robert', 'La Trinité', 'Sainte-Marie', 'Le Gros-Morne'],
  'Centre Atlantique': ['Le François', 'Le Vauclin', 'Saint-Esprit'],
  Sud: [
    'Les Trois-Îlets',
    'Le Diamant',
    'Sainte-Luce',
    'Sainte-Anne',
    'Le Marin',
    'Rivière-Salée',
    'Rivière-Pilote',
    'Les Anses-d’Arlet',
  ],
};

// The sector of a town; a town of no sector is its own.
export const sectorOf = (city) =>
  Object.entries(SECTORS).find(([, cities]) => cities.includes(city))?.[0] ?? (city || 'Autre');

// Where a company is: its own coordinates, or those of its town.
export const coordsOf = (company) => {
  if (company?.lat && company?.lon) return [Number(company.lat), Number(company.lon)];
  return CITY_COORDS[company?.city] ?? null;
};

// The roads of the island wind: 30 % more than as the crow flies.
export const distanceKm = (a, b) => {
  if (!a || !b) return null;
  const toRad = (value) => (value * Math.PI) / 180;
  const dLat = toRad(b[0] - a[0]);
  const dLon = toRad(b[1] - a[1]);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a[0])) * Math.cos(toRad(b[0])) * Math.sin(dLon / 2) ** 2;
  return 2 * 6371 * Math.asin(Math.sqrt(h)) * 1.3;
};

// About 40 km/h on the island, 5 minutes at least between two addresses.
export const travelMinutes = (km) => (km === null ? 0 : Math.max(5, Math.round((km / 40) * 60)));
